import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLinkActive, RouterModule } from '@angular/router';

// Layouts
import { SidepanelComponent } from '../layout/sidepanel/sidepanel.component';
import { SimplePageComponent } from '../layout/simple-page/simple-page.component';

// Services
import { BackendService } from '../services/backend.service';
import { LocalStorageService } from '../services/local-storage.service';
import { RegistrarService } from '../services/registrar.service';
import { UserStateService } from '../services/user-state.service';

import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { LocalePipe } from './pipes/locale.pipe';
import { RegionNamePipe } from './pipes/region-name.pipe';

// Directives
import { TrackFormFieldDirective } from 'ngx-matomo-client/form-analytics';
import { AutoFocusDirective } from './directives/autofocus.directive';
import { ComponentHostDirective } from './directives/component-host.directive';
import { UidFormatDirective } from './directives/uid-format.directive';

import { MaterialModule } from './material.module';
import { SvgIconModule } from './svg-icon.module';

import { CountrySelectorComponent } from '../components/country-selector/country-selector.component';
import { DynamicListComponent } from '../components/dynamic-list/dynamic-list.component';
import { FileDropzoneComponent } from '../components/file-dropzone/file-dropzone.component';
import { KeenSliderComponent } from '../components/keen-slider/keen-slider.component';
import { SearchFieldComponent } from '../components/search-field/search-field.component';

import { BreadcrumbComponent } from '../common/breadcrumb/breadcrumb.component';
import { PageHeaderComponent } from '../common/page-header/page-header.component';
import { FileInputComponent } from '../components/file-input/file-input.component';
import { FilterButtonComponent } from '../components/filter-button/filter-button.component';
import { FilterToolbarComponent } from '../components/filter-toolbar/filter-toolbar.component';
import { SelectComponent } from '../components/select/select.component';
import { SortSelectComponent } from '../components/sort-select/sort-select.component';
import { UppercaseDirective } from './directives/uppercase.directive';
import { CapitalizePipe } from './pipes/capitalize.pipe';

/** list of shared modules */
const modules = [
    CommonModule,
    CountrySelectorComponent,
    DynamicListComponent,
    SearchFieldComponent,
    FormsModule,
    FileInputComponent,
    FilterButtonComponent,
    FileInputComponent,
    FilterToolbarComponent,
    LocalePipe,
    SearchFieldComponent,
    KeenSliderComponent,
    SelectComponent,
    SortSelectComponent,
    ReactiveFormsModule,
    CapitalizePipe,
    EllipsisPipe,
    RegionNamePipe,
    RouterModule,
    MaterialModule,
    BreadcrumbComponent,
    SvgIconModule,
    SimplePageComponent,
    FileDropzoneComponent,
    PageHeaderComponent,
    AutoFocusDirective,
    UidFormatDirective,
    UppercaseDirective,
    RouterLinkActive,
    SidepanelComponent
];

@NgModule( {
    declarations: [],
    providers: [
        BackendService,
        RegistrarService,
        LocalStorageService,
        UserStateService,
        EllipsisPipe,
        LocalePipe,
        RegionNamePipe,
        CapitalizePipe,
        RouterModule,
        AutoFocusDirective,
        ComponentHostDirective,
        TrackFormFieldDirective
    ],
    imports: [...modules],
    exports: [...modules],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
